import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { Roulette } from 'app/public/model/roulette.model';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { Language } from 'app/shared/model/enums';
import { LAST_CONNECTED_LANGUAGE } from 'app/shared/model/local-storage-keys';
import { Subscriber, Subscription } from 'rxjs';

@Component({
  selector: 'app-roulette-design-settings',
  templateUrl: './roulette-design-settings.component.html',
  styleUrls: ['./roulette-design-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class RouletteDesignSettingsComponent implements OnInit {

  @Input()
  roulette: Roulette;

  @Input() form: NgForm;

  spinnersByCategory: Map<number, any> = new Map<number, any>();

  spinnersCategories: { Id: number, Description: string }[];

  _selectedCategory: number;
  get selectedCategory() {
    return this._selectedCategory;
  }
  set selectedCategory(value) {
    if (value !== this._selectedCategory) {
      this._selectedCategory = value;
      this.loadSpinners();
    }
  }

  subscriptions = new Subscription();
  language: Language;

  get currentSpinners() {
    return this.spinnersByCategory.get(this._selectedCategory);
  }
  get selectedSpinnerId() {
    return this.roulette?.Design.Spinner.Id;
  }

  constructor(private rouletteService: WebRouletteService, private cdr: ChangeDetectorRef, store: Store<AppState>) {

    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.language = language;
    }));

  }

  ngOnInit(): void {
    this.loadSpinnersCategories();
  }

  loadSpinnersCategories() {
    this.rouletteService.getSpinnersCategories(this.language).subscribe(res => {
      this.spinnersCategories = res as [];
      this.selectedCategory = 1;

    })
  }

  loadSpinners() {
    if (this._selectedCategory > 0) {
      this.rouletteService.getSpinnersByCategory(this.selectedCategory, this.language).subscribe(
        spinners => {
          this.spinnersByCategory.set(this._selectedCategory, spinners);
          this.cdr.markForCheck();
        }
      );
    }
  }

  selectSpinner(spinner) {
    this.roulette.Design.Spinner = spinner;
    this.form.form.markAsDirty();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
